import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import '../../../../Utility/Public/css/common.scss';
import '../Assets/css/homedoc.scss';
import '../Assets/css/homeresponsivedoc.scss';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import SearchPanel from '../Components/SearchPanel';
import FilterPanel from '../Components/FilterPanel';
import MultiRangeSlider from "../../../../Utility/Components/MultiRangeSlider";
import Pagination from 'react-bootstrap/Pagination';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Utility from '../../../../Utility/Utility';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import { loaderStateTrue, loaderStateFalse, selectChooseBranch, userSearchData, roleWisePermission } from '../../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../../../src/GlobalModules/Login/Actions/LoginAction';
import { connect } from 'react-redux';
import { withRouter, useHistory, useParams } from 'react-router-dom';
import moment from 'moment';
import ModalGlobal from '../../../../Utility/Components/ModalGlobal'
import ReviewContentShowModal from '../Components/ReviewContentShowModal';
import {
  hotelRoomTypesSearchList,
  destinationList
} from '../Controller/HomeController';
import BreadcrumbMenu from '../../../../Utility/Components/BreadcrumbMenu';
import Tooltip from 'react-bootstrap/Tooltip';
import SkeletonThemeContentList from '../../../../Utility/Components/SkeletonThemeContentList';
import LazyImage from '../../../../Utility/Components/LazyImageComponent';
import CancellationDetailsModalContent from '../Components/CancellationDetailsModalContent';
import HotelListItems from '../Components/HotelListItems';
import { serachDataFormatingFn } from '../Model/HomeModel';
function SearchPage(props) {
  // console.group('SearchPage......'); // Commented out to reduce console noise
  const myParam = useParams();
  const [isViewportBottom, setIsViewportBottom] = useState(false);
  const [showAllFlag, setShowAllFlag] = useState(false);
  const [leftSearchFlag, setLeftSearchFlag] = useState("hide-bar");
  const [searchResult, setsearchResult] = useState([]);
  const [searchingDataFromSearchPanel, setSearchingDataFromSearchPanel] = useState({})
  const [dataFromFilterPanel, setDataFromFilterPanel] = useState({})
  const history = useHistory();
  const [reviewShowModalFlag, setReviewShowModalFlag] = useState(false)
  const [ratingDataArr, setRatingDataArr] = useState([])
  const [apiCallFinish, setApiCallFinish] = useState(false)
  const [filterApiCallSuccess, setFilterApiCallSuccess] = useState(false)
  const [overlay, setOverlay] = useState(true)
  const [viewCancellationData, setViewCancellationData] = useState([])
  const [viewCancellationDetailsModalFlag, setViewCancellationDetailsModalFlag] = useState(false)
  const isFilterTriggeredUrlChange = React.useRef(false);

  //show review modal fn
  const showReviewModalFn = (data) => {
    setReviewShowModalFlag(true)
    setRatingDataArr(data)
  }

  //close review modal fn
  const closeReviewModalFn = () => {
    setReviewShowModalFlag(false)
    setRatingDataArr([])
  }

  //Initially fetch user loggedin or not
  useEffect(() => {
    if (!props.isLoggedIn) {
    } else {
      sessionStorage.setItem('previousUrl', `/${localStorage.getItem('i18nextLng')}/search`);
    }
  }, [props.isLoggedIn]);

  // Note: URL parameter parsing is now handled by handleUrlParams function called from the mount useEffect

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      if (scrollTop >= 1050) {
        setIsViewportBottom(true);
      } else {
        setIsViewportBottom(false);
      }
      if (scrollPosition + windowHeight > documentHeight - 600) {

        setIsViewportBottom(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const showAllFN = () => {
    setShowAllFlag(!showAllFlag);
  }

  //filter bar show hide for mobile fn
  const mobFilterFN = () => {
    if (leftSearchFlag == "hide-bar") {
      setLeftSearchFlag("show-bar");
    } else {
      setLeftSearchFlag("hide-bar");
    }
  }

  //filter bar hide cross buttton click for mobile fn
  const crossFN = () => {
    setLeftSearchFlag("hide-bar");
  }

  //search data validation fn
  const validSearchData = () => {
    const { loaderStateTrue, loaderStateFalse, userSearchDataFromReducer } = props;
    let valid = true
    if ((userSearchDataFromReducer.end_date != "" || userSearchDataFromReducer.end_date != null) && (userSearchDataFromReducer.start_date != "" || userSearchDataFromReducer.start_date != null)) {
      const startDate = new Date(userSearchDataFromReducer.start_date);
      const endDate = new Date(userSearchDataFromReducer.end_date);
      const timeDifference = endDate.getTime() - startDate.getTime();
      const differenceInDays = timeDifference / (1000 * 3600 * 24);
      if (differenceInDays > 30) {
        valid = false;
        Utility.toastNotifications("Sorry, reservations for more than 30 nights are not possible.", "Warning", "warning");
      }
    }
    return valid;
  }


  //when some filteration done then hotel search occure
  useEffect(() => {
    if (filterApiCallSuccess) {
      const { loaderStateTrue, loaderStateFalse, userSearchDataFromReducer } = props;
      if (userSearchDataFromReducer?.start_date && userSearchDataFromReducer.start_date != "" && userSearchDataFromReducer?.end_date && userSearchDataFromReducer.end_date != "" &&
        // && userSearchDataFromReducer?.destination && userSearchDataFromReducer.destination != "" && 
        userSearchDataFromReducer?.adult && userSearchDataFromReducer.adult != "") {
        // let allAgesNotEmpty = userSearchDataFromReducer?.children_age?.every(child => child.age !== "");
        let valid = validSearchData();
        if (valid) {
          setFilterApiCallSuccess(false);
          searchHotelBranch();
        } else {
          setsearchResult([])
          setApiCallFinish(true)
          setTimeout(() => {
            setOverlay(false)
          }, 500);
        }
      } else {
        props.history.push(`/${localStorage.getItem('i18nextLng')}/home`);
      }
    }
  }, [filterApiCallSuccess])

  //check filter data will populate or not 
  const filterApiSuccessCheckFn = (data) => {
    setFilterApiCallSuccess(data);
  }

  //date validation check on hotel search
  const searchDateValidation = () => {
    setsearchResult([]);
    setTimeout(() => {
      setOverlay(false)
    }, 500);
  }

  // Track the last search to prevent duplicate searches
  const lastSearchSignature = useRef('');

  //hotel branch search api
  // Modified to accept explicit parameters when called from URL handler
  const searchHotelBranch = (directSearchData = null) => {
    // If we're in the middle of a manual search operation triggered by URL params,
    // and this is a call without directSearchData (from a component), skip it
    if (window.manualSearchTrigger && !directSearchData) {
      // console.log('Skipping redundant search during manual search operation');
      return;
    }
    
    // Use direct search data if provided (from URL parameters), otherwise use Redux state
    const searchData = directSearchData || props.userSearchDataFromReducer;
    
    // Create a search signature for deduplication
    const searchSignature = JSON.stringify({
      destination: searchData?.destination,
      start_date: searchData?.start_date?.toString(),
      end_date: searchData?.end_date?.toString(),
      adult: searchData?.adult,
      children: searchData?.children,
      children_age: JSON.stringify(searchData?.children_age || []),
      filterData: JSON.stringify(searchData?.filterData || {})
    });
    
    // Check if this is a duplicate search
    if (searchSignature === lastSearchSignature.current) {
      // console.log('Skipping duplicate search with identical parameters');
      return;
    }
    
    // Update the last search signature
    lastSearchSignature.current = searchSignature;
    
    // console.log('searchHotelBranch using source:', directSearchData ? 'Direct URL data' : 'Redux state', searchData);
    const { loaderStateTrue, loaderStateFalse } = props;
    setOverlay(true)
    setsearchResult([]);

    // IMPORTANT: Set the flag HERE (before setTimeout) so the URL-change useEffect
    // sees it immediately and does NOT call handleUrlParams() when history.replace fires.
    isFilterTriggeredUrlChange.current = true;

    setTimeout(() => {
      setApiCallFinish(false);
      
      const queryParams = Utility.buildUrlParams(searchData);
      
      // Only update the URL, don't navigate (to prevent page reload)
      const currentPath = history.location.pathname;
      history.replace(`${currentPath}?${queryParams}`);
      //dataset creation
      let formattedData = serachDataFormatingFn(searchData);
      if (props.trendingDestinationData && props.trendingDestinationData.hasOwnProperty('type') && props.trendingDestinationData.type && props.trendingDestinationData.type == 'state') {
        if (searchData.destination && searchData.destination != "" && (typeof searchData.destination === 'object' ? Object.keys(searchData.destination).length > 0 : true)) {
          formattedData['location'] = searchData.destination;
        }
        formattedData['state'] = props.trendingDestinationData?.location;
      } else {
        formattedData['location'] = searchData.destination;
      }
      hotelRoomTypesSearchList(formattedData).then(async (response) => {
        if (response.success) {
          if (response.success) {
            let newDataSet = await formatingSearchData(response.data);
            setsearchResult(newDataSet)
            // Persist the correct searchData back to Redux so SearchPanel
            // sync useEffect does not overwrite local guest counts.
            props.userSearchData(searchData);
            setTimeout(() => {
              setOverlay(false)
            }, 500);
          }
        } else {
          Utility.toastNotifications("Data not found", "Warning", "warning");
        }
      }).catch((error) => {
        console.error("************error*************", error)
        if (error) {
        }
        setApiCallFinish(true)
        setTimeout(() => {
          setOverlay(false)
        }, 500);
        
        // Even on error, update the URL to reflect the attempted search
        const searchParams = new URLSearchParams();
        if (searchData.destination) {
          searchParams.set('destination', typeof searchData.destination === 'string' ? 
            searchData.destination : JSON.stringify(searchData.destination));
        }
        if (searchData.start_date) {
          searchParams.set('startDate', moment(searchData.start_date).format('YYYY-MM-DD'));
        }
        if (searchData.end_date) {
          searchParams.set('endDate', moment(searchData.end_date).format('YYYY-MM-DD'));
        }
        if (searchData.adult) {
          searchParams.set('adult', searchData.adult);
        }
        const currentPath = history.location.pathname;
        isFilterTriggeredUrlChange.current = true;
        history.replace(`${currentPath}?${searchParams.toString()}`);
        if (error.message == "Network Error") {
        }
      });
    }, 500);
  }

  //after geting branch search result
  useEffect(() => {
    const { loaderStateTrue, loaderStateFalse, userSearchDataFromReducer } = props;
    if (searchResult) {
      setApiCallFinish(true)
    }
  }, [searchResult]);


  //formatting branch data from search response
  const formatingSearchData = async (data) => {
    let branchArray = [];
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        for (let b = 0; b < data[i].branch_details.length; b++) {
          let newKeydata = data[i].branch_details[b];
          newKeydata["hotel_details"] = data[i].hotel_details
          branchArray.push(newKeydata)
        }
      }
    }
    return branchArray;
  }

  // Callback function to receive data from the FilterPanel child component
  const receiveDataFromFilterPanel = (data) => {
    setDataFromFilterPanel(data);
  };

  //breadcrumb menu click fn
  const homeMenuClick = () => {
    props.history.push(`/${localStorage.getItem('i18nextLng')}/home`);
  }
  const hotelListClick = () => {
    props.history.push(`/${localStorage.getItem('i18nextLng')}/search`);
  }
  const hotelDetailsClick = () => {
    props.history.push(`/${localStorage.getItem('i18nextLng')}/property-details`);
  }

  const bookingListClick = () => {
    props.history.push(`/${localStorage.getItem('i18nextLng')}/booking-history`);
  }

  //when land on search page scroll to top position
  useEffect(() => {
    console.log('Search page mounted, checking URL parameters');
    breadcrumbUrlFn();
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
    
    // Initial parse of URL parameters when component first mounts
    handleUrlParams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run only once on mount
  
  // Track the last processed URL search params to avoid duplicate processing
  const lastProcessedUrlParams = useRef('');

  // Separate effect to monitor URL changes
  useEffect(() => {
    // Only process URL changes that aren't triggered internally by filter updates
    // and only if there are actually search parameters in the URL
    const currentUrlParams = history.location.search;
    
    if (!isFilterTriggeredUrlChange.current && 
        currentUrlParams && 
        currentUrlParams !== lastProcessedUrlParams.current) {
      
      // console.log('External URL change detected, updating parameters');
      // Save this URL to prevent reprocessing the same URL
      lastProcessedUrlParams.current = currentUrlParams;
      handleUrlParams();
    } else {
      // Reset the flag after ignoring this update
      // IMPORTANT: Also update lastProcessedUrlParams so we don't process it later!
      lastProcessedUrlParams.current = currentUrlParams;
      isFilterTriggeredUrlChange.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.search]); // Re-run when URL changes using history.location

  // Separate function to handle URL parameters
  const handleUrlParams = () => {
    const searchData = Utility.decodeUrlParams(history.location.search);
    
    if (["destination", "start_date", "end_date", "adult"].some(key => searchData.hasOwnProperty(key) && searchData[key])) {
      
      // IMPORTANT: Only update Redux state with the URL parameters
      // The existing useEffect that watches for Redux state changes will trigger the search
      // console.log('Updating Redux with URL parameters:', searchData);
      
      // First store the current Redux state
      const currentState = props.userSearchDataFromReducer || {};
      
      // Create a complete copy of state to ensure we don't lose any fields
      // and explicitly assign the values that we want to update from URL
      const mergedState = {
        ...currentState,
        // Explicitly assign these fields to ensure they're updated
        destination: searchData.destination || currentState.destination || "",
        start_date: searchData.start_date || currentState.start_date,
        end_date: searchData.end_date || currentState.end_date,
        adult: searchData.adult || currentState.adult,
        children: searchData.children !== undefined ? searchData.children : currentState.children || 0,
        // Make sure we're explicitly setting the children_age array 
        children_age: (searchData.children_age && searchData.children_age.length > 0) ? searchData.children_age : currentState.children_age || [],
        filterData: {
          ...(currentState.filterData || {}),
          ...(searchData.filterData || {})
        }
      };
      // console.log('Updating Redux with URL parameters mergedState:', mergedState);
      // Create a signature of current state to compare with existing Redux state
      const currentStateSignature = JSON.stringify({
        destination: mergedState.destination,
        start_date: mergedState.start_date?.toString(),
        end_date: mergedState.end_date?.toString(),
        adult: mergedState.adult,
        children: mergedState.children,
        children_age: JSON.stringify(mergedState.children_age || []),
        filterData: JSON.stringify(mergedState.filterData || {})
      });
      
      // Get a signature of the existing Redux state for comparison
      const existingStateSignature = JSON.stringify({
        destination: props.userSearchDataFromReducer?.destination,
        start_date: props.userSearchDataFromReducer?.start_date?.toString(),
        end_date: props.userSearchDataFromReducer?.end_date?.toString(),
        adult: props.userSearchDataFromReducer?.adult,
        children: props.userSearchDataFromReducer?.children,
        children_age: JSON.stringify(props.userSearchDataFromReducer?.children_age || []),
        filterData: JSON.stringify(props.userSearchDataFromReducer?.filterData || {})
      });
      
      // Only update Redux if the state is actually different
      if (currentStateSignature !== existingStateSignature) {
        // console.log('URL params different from Redux state, updating Redux...');
        // Update Redux with the merged state
        props.userSearchData(mergedState);
        
        if (!(mergedState.start_date && mergedState.end_date && mergedState.adult)) {
          // console.log('Not enough data in URL parameters to perform a valid search');
          return;
        }
        
        // Only perform a search if we have all required data and it's not already in progress
        // console.log('Performing search based on URL parameters');
        
        // Set a flag to indicate we're manually triggering a search and should skip further updates
        window.manualSearchTrigger = true;
        
        // We need to directly call searchHotelBranch with the mergedState to ensure it has the latest data
        // Call just once - the searchHotelBranch function now has its own deduplication
        searchHotelBranch(mergedState);
        
        // Reset the flag after a delay to allow future searches
        setTimeout(() => {
          window.manualSearchTrigger = false;
        }, 1000);
      } else {
        // console.log('URL params match Redux state, skipping update');
      }
    }
  };

  //breadcrumb menu option function
  const breadcrumbUrlFn = () => {
    try {
      // Safely get and parse pageArr from localStorage
      let breadcrumb = [];
      const pageArrString = localStorage.getItem('pageArr');
      if (pageArrString) {
        try {
          breadcrumb = JSON.parse(pageArrString);
          // Ensure breadcrumb is an array
          if (!Array.isArray(breadcrumb)) {
            breadcrumb = [];
          }
        } catch (e) {
          // If parsing fails, initialize as empty array
          breadcrumb = [];
        }
      }
      
      // Find search index safely
      const searchIndex = breadcrumb.indexOf('search');
      let newArray = searchIndex >= 0 ? breadcrumb.slice(0, searchIndex + 1) : breadcrumb;
      
      if (!breadcrumb.includes('search')) {
        breadcrumb.push('search');
        localStorage.setItem('pageArr', JSON.stringify(breadcrumb));
      } else {
        localStorage.setItem('pageArr', JSON.stringify(newArray));
      }
    } catch (error) {
      // Fallback if anything goes wrong
      console.error('Error in breadcrumb handling:', error);
      try {
        localStorage.setItem('pageArr', JSON.stringify(['search']));
      } catch (e) {
        // Last resort if localStorage is unavailable
        console.error('Failed to access localStorage:', e);
      }
    }
  }

  //view cancellation details data set
  const viewCancellationDetails = (data) => {
    setViewCancellationData(data);
  }

  // Removed the useEffect that forced componentKey updates on URL changes,
  // as it caused SearchPanel/FilterPanel to unmount and remount, resulting in flickering
  // and state resets.
  const lastUrlParams = useRef('');
  
  useEffect(() => {
    if (viewCancellationData.length > 0) {
      setViewCancellationDetailsModalFlag(true)
    }
  }, [viewCancellationData])

  //cancellation details modal close fn
  const closeCancellationDetailsModalFn = () => {
    setViewCancellationData([])
    setViewCancellationDetailsModalFlag(false)
  }

  return (
    <>
      {overlay &&
        <div className='overlayBox'></div>}
      <div className='searchPageBox'>
        <div className='searchPanel searchPanelInner'>
          <SearchPanel
            searchDateValidation={searchDateValidation}
            callFrom="search"
            searchHotelBranch={searchHotelBranch}
          />
        </div>
        <div className='clearfix'></div>
        <div className='breadcrumbPanelSec'>
          <div className='container'>
            <BreadcrumbMenu
              homeMenuDisplay={localStorage.getItem('pageArr') ? JSON.parse(localStorage.getItem('pageArr') || '[]').includes('home') : false}
              hotelListDisplay={localStorage.getItem('pageArr') ? JSON.parse(localStorage.getItem('pageArr') || '[]').includes('search') : false}
              hotelDetailsDisplay={localStorage.getItem('pageArr') ? JSON.parse(localStorage.getItem('pageArr') || '[]').includes('hotel-details') : false}
              bookingListDisplay={localStorage.getItem('pageArr') ? JSON.parse(localStorage.getItem('pageArr') || '[]').includes('booking-history') : false}
              homeMenuClick={homeMenuClick}
              hotelListClick={hotelListClick}
              hotelDetailsClick={hotelDetailsClick}
              bookingListClick={bookingListClick}
              activeHotelList={true}
            />
          </div>
        </div>
        <div className='searchBodyPanel'>
          <div className='container'>
            <div className='innSearchBodyPanel'>
              <div className='row'>
                <div className='mob-filter'>
                  <button onClick={() => { mobFilterFN() }}><i className="fa fa-filter" aria-hidden="true"></i>
                    Filter</button>
                </div>

                <FilterPanel
                  leftSearchFlag={leftSearchFlag}
                  crossFN={crossFN}
                  sendDataToParent={receiveDataFromFilterPanel}
                  searchHotelBranch={searchHotelBranch}
                  filterApiSuccessCheckFn={filterApiSuccessCheckFn}
                />
                {apiCallFinish ?
                  <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12 hotelList">
                    <div className='searchRight'>
                      {searchingDataFromSearchPanel.start_date && searchingDataFromSearchPanel.start_date != "" && searchingDataFromSearchPanel.end_date && searchingDataFromSearchPanel.end_date != "" &&
                        <h6><span>{searchingDataFromSearchPanel.destination}</span>: <span>{searchResult.length}</span> properties found <em>[{Utility.calculateDaysNights(searchingDataFromSearchPanel.start_date, searchingDataFromSearchPanel.end_date)} night, {searchingDataFromSearchPanel.adult} adults, {searchingDataFromSearchPanel.children} child]</em></h6>
                      }
                      <div className='hotelListBoxes'>
                        <HotelListItems searchResult={searchResult} {...props} adult={searchingDataFromSearchPanel.adult} child={searchingDataFromSearchPanel.children} start_date={searchingDataFromSearchPanel.start_date} end_date={searchingDataFromSearchPanel.end_date} showReviewModalFn={showReviewModalFn} apiCallFinish={apiCallFinish
                        } viewCancellationDetails={viewCancellationDetails} />
                      </div>
                    </div>
                  </div> :
                  <SkeletonThemeContentList />
                }
              </div>
            </div>
          </div>
        </div>
        <ErrorBoundary title="ModalGlobal Error">
          <ModalGlobal
            show={reviewShowModalFlag}
            onHide={closeReviewModalFn}
            title="Review"
            className="modalcustomize mondimension reviewDialogModal"
            footer={false}
            closeButton={true}
            saveButtonLabel="Submit"
            saveButtonClassName="modbtn savebtn"
            cancelShow={false}
            saveShow={false}
            onCancel={closeReviewModalFn}
            cancelButtonClassName="modbtn cancelbtn"
            footerClassName="text-center topspace"
            body={
              <>
                <ErrorBoundary title="ReviewContentShowModal Error">
                  <ReviewContentShowModal
                    ratingData={ratingDataArr}
                  />
                </ErrorBoundary>
              </>
            }
          />
        </ErrorBoundary>

        <ErrorBoundary title="ModalGlobal Error">
          <ModalGlobal
            show={viewCancellationDetailsModalFlag}
            onHide={closeCancellationDetailsModalFn}
            title={viewCancellationData.length > 1 ? "Cancellation Rules" : 'Cancellation Rule'}
            className="modalcustomize mondimension reviewDialogModal cancellationRuleModal"
            footer={false}
            closeButton={true}
            saveButtonLabel="Submit"
            saveButtonClassName="modbtn savebtn"
            cancelShow={false}
            saveShow={false}
            onCancel={closeCancellationDetailsModalFn}
            cancelButtonClassName="modbtn cancelbtn"
            footerClassName="text-center topspace"
            body={
              <>
                <ErrorBoundary title="cancellation details Error">
                  <CancellationDetailsModalContent
                    viewCancellationData={viewCancellationData}
                  />
                </ErrorBoundary>
              </>
            }
          />
        </ErrorBoundary>
      </div>
    </>
  );

}
const mapStateToProps = (globalState) => {
  return {
    userCredentials: globalState.LoginReducer.userCredentials,
    userSearchDataFromReducer: globalState.mainReducerData.userSearchData,
    trendingDestinationData: globalState.mainReducerData.trendingDestination
  };
}


export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials, logOutApp, roleWisePermission, userSearchData, setToken, selectChooseBranch })(SearchPage);
